/**
 * @generated SignedSource<<b833f51a76dd20b104cbde494e5d26da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionScoringCriteriaFragmentQuery$variables = {
  id: string;
  owner: string;
  stage?: number | null | undefined;
};
export type CompetitionScoringCriteriaFragmentQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionScoringCriteriaFragment">;
  };
};
export type CompetitionScoringCriteriaFragmentQuery = {
  response: CompetitionScoringCriteriaFragmentQuery$data;
  variables: CompetitionScoringCriteriaFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stage"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "kind": "Variable",
  "name": "stage",
  "variableName": "stage"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionScoringCriteriaFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "owner",
                "variableName": "owner"
              },
              (v4/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "CompetitionScoringCriteriaFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionScoringCriteriaFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "slug",
                    "variableName": "owner"
                  }
                ],
                "concreteType": "EventCompetition",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v4/*:: as any*/)
                ],
                "concreteType": "CompetitionStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seq",
                    "storageKey": null
                  },
                  {
                    "alias": "viewerCanEdit",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "UPDATE_COMPETITION_STAGE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"UPDATE_COMPETITION_STAGE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionScoringCriterion",
                    "kind": "LinkedField",
                    "name": "scoringCriteria",
                    "plural": true,
                    "selections": [
                      (v5/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weight",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Competition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b897d1cda12389e4caa96a9ef216d074",
    "id": null,
    "metadata": {},
    "name": "CompetitionScoringCriteriaFragmentQuery",
    "operationKind": "query",
    "text": "query CompetitionScoringCriteriaFragmentQuery(\n  $owner: String!\n  $stage: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CompetitionScoringCriteriaFragment_1X6Izt\n    id\n  }\n}\n\nfragment CompetitionScoringCriteriaFragment_1X6Izt on Competition {\n  slug\n  event(slug: $owner) {\n    event {\n      slug\n      id\n    }\n    id\n  }\n  stage(stage: $stage) {\n    seq\n    viewerCanEdit: viewerCan(action: UPDATE_COMPETITION_STAGE)\n    scoringCriteria {\n      id\n      title\n      description\n      weight\n    }\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "fabbf8fb7fe48f98b19ec1bf0958627b";

export default node;
